import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

export function DriveErrorState({ message, onRetry, compact = false }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        padding: compact ? "16px" : "32px 16px",
        background: "#fef2f2",
        border: "1px solid #fecaca",
        borderRadius: 8,
        color: "#991b1b",
        textAlign: "center",
      }}
      role="alert"
    >
      <AlertTriangle size={compact ? 20 : 32} color="#dc2626" />
      <div style={{ fontSize: compact ? 13 : 14, fontWeight: 500 }}>
        {message || "No se pudieron cargar los archivos"}
      </div>
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            padding: "6px 14px",
            background: "#fff",
            color: "#991b1b",
            border: "1px solid #fecaca",
            borderRadius: 6,
            fontSize: 13,
            fontWeight: 500,
            cursor: "pointer",
          }}
        >
          <RefreshCw size={14} /> Reintentar
        </button>
      )}
    </div>
  );
}
